<script setup>
import { computed, ref, watch, nextTick, toRaw } from "vue";
import { useCurrentMenuStore } from "../../stores/current-menu";

import Modal from "@/components/Modal";

const props = defineProps({
  items: { required: true },
  category: { required: true },
  is_option: { required: false }
});
const emit = defineEmits(["addItem", "addOption"]);

const allItems = toRaw(props.items);

const searchInput = ref("");

const input = ref(null);

const modalOpen = ref(false);

const currentMenuStore = useCurrentMenuStore();

const currentTab = computed(function () {
  const tab = currentMenuStore.currentTab;
  switch (tab) {
    case 'food':
      return 'Dish';
    case 'drink':
      return 'Drink';
    default:
      return '';
  }
});


function search() {
  return allItems.filter((item) => {
    return item.product_id.toLowerCase().match(searchInput.value.toLowerCase());
  });
}

const searchItems = computed(search);

watch(input, (value) => {
  if (input.value) {
    input.value.focus();
  }
});

function toggleModal() {
  modalOpen.value = !modalOpen.value;
}

function addItem(item, is_option = false) {
  if (is_option) {
    emit('addOption', item);
    searchInput.value = '';
    modalOpen.value = false;
    return;
  } else {
    emit("addItem", item);
    searchInput.value = '';
    modalOpen.value = false;
    return;
  }
}


</script>

<template>
  <div class="link-add" @click="modalOpen = true"><span>+</span> Add {{ currentTab }}</div>
  <Modal :active="modalOpen" @toggle="toggleModal">
    <input type="text" placeholder="Product ID" @change="search" v-model="searchInput" ref="input" />
    <div class="results">
      <ul v-if="searchInput">
        <li v-for="item in searchItems" @click="addItem(item, props.is_option)">
          <p>{{ item.item }}</p>
          <small>Measure: {{ item.measure }}</small><br />
          <small>Product ID: {{ item.product_id }}</small>
        </li>
      </ul>
    </div>
  </Modal>
</template>

<style scoped lang="scss">
.link-add {
  cursor: pointer;
  display: flex;
  gap: 10px;

  span {
    color: var(--green);
    height: 20px;
    width: 20px;
    background-color: white;
    border-radius: 100px;
    text-align: center;
    line-height: 20px;
  }

}

.modal {
  input {
    position: sticky;
    top: 0;
  }

  .results {
    li {
      padding: 10px;
      border: 1px solid #ccc;
      margin: 5px 0;
      list-style: none;
      cursor: pointer;
      transition: 0.3s ease;

      &:hover {
        background: #ccc;
      }
    }
  }
}
</style>
